export default __webpack_public_path__ + "static/media/ThanksForOrder.c82d0cfc.png";